<template>
  <div class="dinA4">
    <img :src="require('@/assets/header.png')" class="mb-12 page__header" />
    <div class="page__container">
      
      <p class="body-1 body-1--bold mb-12">
        {{ $t('PAGE2_P1_PT', { name: clientData.name }) }}
      </p>
      <p class="body-1 mb-12">
        {{ $t('PAGE2_P2_PT') }}
      </p>
      <p class="body-1 mb-12">
        {{ $t('PAGE2_P3_PT') }}
      </p>
      <p class="body-1 mb-12">
        {{ $t('PAGE2_P4_PT') }}
      </p>
      <p class="body-1 mb-8">
        {{ $t('PAGE2_P5_PT') }}
      </p>
      <img :src="require('@/assets/firma-pt.png')" class="director-signature" />
      <p class="body-1 mb-0">
        {{ $t('PAGE2_DIRECTOR_NAME_PT') }}
      </p>
      <p class="body-2 mb-12">
        {{ $t('PAGE2_DIRECTOR_JOB_PT') }}
      </p>
      <div class="d-flex justify-end mt-12 body-1">{{legalCity}}, {{ date }}</div>
      <div class="commercial-name">
        <p class="body-1"><span class="body-1--bold">{{ $t('PAGE2_COMMERCIAL_PT') }}</span>{{ commercialName }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'

export default {
  name: 'Letter',
  data() {
    return {}
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    commercialName() {
      return this[GET_OFFER_ITEM]('commercial')
    },
    clientData() {
      return this[GET_OFFER_ITEM]('client')
    },
    legalCity(){
      return this[GET_OFFER_ITEM]('legalCity');
    },
    date() {
      let f = new Date()
      return 'a ' + f.getDate() + '/' + (Number(f.getMonth()) + 1) + '/' + f.getFullYear()
    },
  },
}
</script>

<style scoped lang="scss">
  .commercial-name {
    width: fit-content;
    position: relative;
    top: 1mm;
    padding: 1px;
    padding-top: 0px;
    border-style: solid;
    border-width: 1px;
    border-color: #cccccc;
  }
</style>
